import { xhr } from '@/api/config/Repository'
import CreateLPRepository from '../CreateLPRepository'
import CreateLPRequestDTO from '../dto/CreateLPRequestDTO'
export default class CreateLPRepositoryImpl implements CreateLPRepository {
  async createLPData (request): Promise<any> {
    const endpoint = 'lp/createLPManual'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const formData = request.data
    const response = await xhr.post<CreateLPRequestDTO, any>(endpoint, formData, { headers })
    console.log('LOG~ ~ file: CreateLPRepositoryImpl.ts:10 ~ CreateLPRepositoryImpl ~ createLPData ~ response:', response)
    return {
      content: response.data,
      status: response.status
    }
  }
}
